module.exports = __webpack_public_path__ + "assets/avatar_suv.b99ba119.svg";